import { useMutation, useQueryClient } from "@tanstack/react-query";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";

type SellerSwitchStoreInput = {
  storeSlug: string;
};

export function useSwitchStoreMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    meta: { skipGlobalErrorToast: true },
    mutationFn: (input: SellerSwitchStoreInput) =>
      apiJsonClient<unknown>(endpoints.seller.auth.switchStore, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(input),
      }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["seller"] });
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
